module.exports = __webpack_public_path__ + "img/name-logo.e8ce3292.png";